import { render } from "./FormatAlignLeft.vue?vue&type=template&id=7de60a2a"
import script from "./FormatAlignLeft.vue?vue&type=script&lang=js"
export * from "./FormatAlignLeft.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__